import isEqual from "lodash/isEqual"
import React, { useEffect } from "react"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import { SaveButton } from "../../common/button"
import { StaticFooter } from "../../common/footer"
import { Header } from "../../common/headers"
import LoadingSpinner from "../../common/spinner/loading.component"
import IntlProps from "../../state/helpers/IntlProps"
import { InventoryConfigurationAction } from "../../state/inventory/configuration/actions"
import { InventoryConfigurationSelector } from "../../state/inventory/configuration/selectors"
import { SETTINGS_PAGE_MESSAGES } from "../../utils/inventory"
import { MainTabsComponent } from "../components"
import { SettingsCostMethodSection, SettingsEnableModuleSection } from "../sections"

export const Settings = injectIntl((props: IntlProps) => {
    const dispatch = useDispatch()
    const state = useSelector(InventoryConfigurationSelector.get)
    const [initialState, setInitialState] = React.useState(state)

    useEffect(() => {
        dispatch(InventoryConfigurationAction.fetch())
    }, [])

    useEffect(() => {
        setInitialState(state)
    }, [state.id])

    const loading = !!state.id
    if (!loading) {
        return <LoadingSpinner/>
    }

    const onSave = () => {
        dispatch(InventoryConfigurationAction.save())

        setTimeout(() => {
            setInitialState(state)
        }, 1000)
    }

    const hasChanged = () => {
        return !isEqual(initialState, state)
    }

    return (
        <>
            <MainTabsComponent enabledOverride={initialState.enabled}/>
            <Header title={props.intl.formatMessage(SETTINGS_PAGE_MESSAGES["header"])}/>
            <hr/>
            <SettingsEnableModuleSection/>

            {state.enabled &&
                <SettingsCostMethodSection/>
            }

            {hasChanged() &&
                <StaticFooter>
                    <div className="row justify-content-end">
                        <SaveButton onClickCallback={onSave}/>
                    </div>
                </StaticFooter>
            }

        </>
    )
})




// WEBPACK FOOTER //
// ./src/inventory/pages/Settings.tsx